module.exports = __webpack_public_path__ + "static/img/200188.2cbe36eb.png";